import { render, staticRenderFns } from "./uf_is_production_industrial.vue?vue&type=template&id=65344386&scoped=true"
import script from "./uf_is_production_industrial.vue?vue&type=script&lang=js"
export * from "./uf_is_production_industrial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65344386",
  null
  
)

export default component.exports